<template lang="html">
  <div :class="`w-100 d-flex align-items-center ${justifyEnd ? 'justify-content-end' : 'justify-content-start'}`">
    <div class="avatar-wrapper">
      <img :src="avatarSrc" class="avatar-img" :alt="fullname" :title="fullname">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewConsultantBox',
  props: {
    avatarSrc: String,
    fullname: String,
    justifyEnd: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style scoped>
.avatar-wrapper {
  width: 24px;
  aspect-ratio: 1 / 1;
  position: relative;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50% !important;
  display: block;
}
</style>
